/** Centralized react-query cache keys so mutations invalidate the right queries. */
export const queryKeys = {
  config: {
    current: ["config", "current"] as const,
    versions: ["config", "versions"] as const,
  },
  homeBlocks: {
    list: ["home-blocks"] as const,
  },
  daily: {
    content: ["daily", "content"] as const,
    verse: ["daily", "verse", "current"] as const,
    reflection: ["daily", "reflection", "current"] as const,
  },
  notifications: {
    list: ["notifications"] as const,
  },
  audit: {
    list: (filters: unknown) => ["audit", filters] as const,
  },
  sessions: {
    list: ["sessions"] as const,
  },
  publicApi: {
    health: ["public", "health"] as const,
    emergencyState: ["public", "emergency-state"] as const,
  },
};
